import React from "react";
import CommentForm from "./CommentForm";
import SecurityFSSP from "./SecurityFSSP";
import SecurityGIBDD from "./SecurityGIBDD";
import SecurityPayments from "./SecurityPayments";
import SecurityGPS from "./SecurityGPS";
import SecurityLoan from "./SecurityLoan";
import SecurityChecks from "./SecurityChecks";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

class SecurityControls extends React.Component {
    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { car, userPermissions, onAddComment, onDeleteComment } = this.props;
        const { contract: {
                    _id,
                    creationDate,
                    carDetails: {vin} = {},
                    clientDetails = {},
                    payments,
                    sumLog,
                    programDetails: {
                        sum,
                        rates,
                        programType,
                        duration,
                        isLeasingPrepayed,
                        preferentialRepayment,
                        preferentialPeriod } = {},
                    securityDetails: {
                        fssp = [],
                        gibdd = [],
                        gpsNotes = [],
                        terror = [],
                        loanNumber,
                        gpsStatus } = {},
                } = {},
                loan: {
                    phoneCalls = []
                } = {}} = car;
        const { value, fsspData } = this.state;

        const tabs = [
            { label: "Платежи", icon: <PersonAddIcon /> },
            { label: "Комментарии", icon: <PersonAddIcon /> },
            { label: "ФССП", icon: <PersonAddIcon /> },
            { label: "ГИБДД", icon: <PersonAddIcon /> },
            { label: "ПОД / ФТ", icon: <PersonAddIcon /> },
            { label: "Данные GPS", icon: <PersonAddIcon /> },
            { label: "Залог", icon: <PersonAddIcon /> }
        ];

        return (
            <React.Fragment>
                <Tabs value={value}
                      onChange={this.switchTab}
                      centered >
                    {tabs.map((tab, i) => <Tab key={i}
                                               label={tab.label}
                                               icon={tab.icon} />
                    )}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x" style={{ overflow: "hidden", paddingTop: 10 }}>
                        {value === 0 && <SecurityPayments sum={sum}
                                                          contractId={_id}
                                                          rates={rates}
                                                          payments={payments}
                                                          sumLog={sumLog}
                                                          programType={programType}
                                                          duration={duration}
                                                          isLeasingPrepayed={isLeasingPrepayed}
                                                          preferentialRepayment={preferentialRepayment}
                                                          preferentialPeriod={preferentialPeriod}
                                                          creationDate={creationDate} /> }
                    </div>
                    <div dir="x">
                        {value === 1 && <CommentForm car={car._id}
                                                     onAddComment={onAddComment}
                                                     onDeleteComment={onDeleteComment}
                                                     userPermissions={userPermissions}
                                                     comments={phoneCalls} />}
                    </div>
                    <div dir="x" style={{ overflow: "hidden", padding: 10 }}>
                        {value === 2 && <SecurityFSSP contractId={_id}
                                                      clientDetails={clientDetails}
                                                      fsspData={fsspData}
                                                      fssp={fssp} /> }
                    </div>
                    <div dir="x">
                        {value === 3 && <SecurityGIBDD contractId={_id}
                                                       vin={vin}
                                                       gibdd={gibdd}  /> }
                    </div>
                    <div dir="x">
                        {value === 4 && <SecurityChecks contractId={_id}
                                                        terror={terror}
                                                        clientLastname={clientDetails.lastname}
                                                        clientFirstname={clientDetails.firstname} /> }
                    </div>
                    <div dir="x">
                        {value === 5 && <SecurityGPS contractId={_id}
                                                     gpsStatus={gpsStatus}
                                                     gps={gpsNotes}  /> }
                    </div>
                    <div dir="x">
                        {value === 6 && <SecurityLoan contractId={_id}
                                                      creationDate={creationDate}
                                                      duration={duration}
                                                      number={loanNumber}
                                                      vin={vin} /> }
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default SecurityControls;



// WEBPACK FOOTER //
// ./src/components/SecurityControls.js